export const campaignQueryKeys = {
  all: ["campaigns"] as const,
  lists: () => [...campaignQueryKeys.all, "list"] as const,
  list: (params: unknown) => [...campaignQueryKeys.lists(), params] as const,
  infinites: () => [...campaignQueryKeys.all, "infinite"] as const,
  infinite: (params: {
    clientId?: string;
    descending?: boolean;
    orderBy?: string;
    search?: string;
    includeIntegrations?: boolean;
    statuses?: string[];
  }) =>
    [
      ...campaignQueryKeys.infinites(),
      params.clientId,
      params.descending,
      params.orderBy,
      params.search,
      params.includeIntegrations,
      params.statuses,
    ] as const,
  details: () => [...campaignQueryKeys.all, "detail"] as const,
  detail: (campaignId: string, clientId?: string) =>
    [...campaignQueryKeys.details(), campaignId, clientId] as const,
};
